
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93MPtsWYWsTpMeta } from "/codebuild/output/src4287943582/src/gx-booking/pages/[...slug].vue?macro=true";
import { default as _404pIgUzU4AhPMeta } from "/codebuild/output/src4287943582/src/gx-booking/pages/404.vue?macro=true";
import { default as _91_91filter_93_93uPCoRGZHZPMeta } from "/codebuild/output/src4287943582/src/gx-booking/pages/account/bookings/[[filter]].vue?macro=true";
import { default as index2ExNl9C1jGMeta } from "/codebuild/output/src4287943582/src/gx-booking/pages/account/index.vue?macro=true";
import { default as notificationsNF1LUYsEcsMeta } from "/codebuild/output/src4287943582/src/gx-booking/pages/account/notifications.vue?macro=true";
import { default as paymentsyPV2jU9IQJMeta } from "/codebuild/output/src4287943582/src/gx-booking/pages/account/payments.vue?macro=true";
import { default as personal_45infoRpcPptPmUHMeta } from "/codebuild/output/src4287943582/src/gx-booking/pages/account/personal-info.vue?macro=true";
import { default as securitytDDGnDiD5DMeta } from "/codebuild/output/src4287943582/src/gx-booking/pages/account/security.vue?macro=true";
import { default as confirmSRIO9129x8Meta } from "/codebuild/output/src4287943582/src/gx-booking/pages/experiences/[parentId]/[serviceId]/confirm.vue?macro=true";
import { default as indexKpPy8RHAbnMeta } from "/codebuild/output/src4287943582/src/gx-booking/pages/experiences/[parentId]/[serviceId]/index.vue?macro=true";
import { default as _91bookingId_93Hm7GlqzOzcMeta } from "/codebuild/output/src4287943582/src/gx-booking/pages/experiences/[parentId]/[serviceId]/return/[bookingId].vue?macro=true";
import { default as _91accessKey_9358sZrdmn69Meta } from "/codebuild/output/src4287943582/src/gx-booking/pages/gratuity/[accessKey].vue?macro=true";
import { default as loginhf4hiCntNTMeta } from "/codebuild/output/src4287943582/src/gx-booking/pages/login.vue?macro=true";
import { default as _91code_93JUBzR0Yw8VMeta } from "/codebuild/output/src4287943582/src/gx-booking/pages/referral/[code].vue?macro=true";
import { default as reset_45passwordDpEdo1m414Meta } from "/codebuild/output/src4287943582/src/gx-booking/pages/reset-password.vue?macro=true";
import { default as set_45passwordkg2xENniYRMeta } from "/codebuild/output/src4287943582/src/gx-booking/pages/set-password.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93MPtsWYWsTpMeta || {},
    component: () => import("/codebuild/output/src4287943582/src/gx-booking/pages/[...slug].vue")
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/codebuild/output/src4287943582/src/gx-booking/pages/404.vue")
  },
  {
    name: "account-bookings-filter",
    path: "/account/bookings/:filter?",
    meta: _91_91filter_93_93uPCoRGZHZPMeta || {},
    component: () => import("/codebuild/output/src4287943582/src/gx-booking/pages/account/bookings/[[filter]].vue")
  },
  {
    name: "account",
    path: "/account",
    meta: index2ExNl9C1jGMeta || {},
    component: () => import("/codebuild/output/src4287943582/src/gx-booking/pages/account/index.vue")
  },
  {
    name: "account-notifications",
    path: "/account/notifications",
    meta: notificationsNF1LUYsEcsMeta || {},
    component: () => import("/codebuild/output/src4287943582/src/gx-booking/pages/account/notifications.vue")
  },
  {
    name: "account-payments",
    path: "/account/payments",
    meta: paymentsyPV2jU9IQJMeta || {},
    component: () => import("/codebuild/output/src4287943582/src/gx-booking/pages/account/payments.vue")
  },
  {
    name: "account-personal-info",
    path: "/account/personal-info",
    meta: personal_45infoRpcPptPmUHMeta || {},
    component: () => import("/codebuild/output/src4287943582/src/gx-booking/pages/account/personal-info.vue")
  },
  {
    name: "account-security",
    path: "/account/security",
    meta: securitytDDGnDiD5DMeta || {},
    component: () => import("/codebuild/output/src4287943582/src/gx-booking/pages/account/security.vue")
  },
  {
    name: "experiences-parentId-serviceId-confirm",
    path: "/experiences/:parentId()/:serviceId()/confirm",
    meta: confirmSRIO9129x8Meta || {},
    component: () => import("/codebuild/output/src4287943582/src/gx-booking/pages/experiences/[parentId]/[serviceId]/confirm.vue")
  },
  {
    name: "experiences-parentId-serviceId",
    path: "/experiences/:parentId()/:serviceId()",
    meta: indexKpPy8RHAbnMeta || {},
    component: () => import("/codebuild/output/src4287943582/src/gx-booking/pages/experiences/[parentId]/[serviceId]/index.vue")
  },
  {
    name: "experiences-parentId-serviceId-return-bookingId",
    path: "/experiences/:parentId()/:serviceId()/return/:bookingId()",
    meta: _91bookingId_93Hm7GlqzOzcMeta || {},
    component: () => import("/codebuild/output/src4287943582/src/gx-booking/pages/experiences/[parentId]/[serviceId]/return/[bookingId].vue")
  },
  {
    name: "gratuity-accessKey",
    path: "/gratuity/:accessKey()",
    meta: _91accessKey_9358sZrdmn69Meta || {},
    component: () => import("/codebuild/output/src4287943582/src/gx-booking/pages/gratuity/[accessKey].vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginhf4hiCntNTMeta || {},
    component: () => import("/codebuild/output/src4287943582/src/gx-booking/pages/login.vue")
  },
  {
    name: "referral-code",
    path: "/referral/:code()",
    meta: _91code_93JUBzR0Yw8VMeta || {},
    component: () => import("/codebuild/output/src4287943582/src/gx-booking/pages/referral/[code].vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordDpEdo1m414Meta || {},
    component: () => import("/codebuild/output/src4287943582/src/gx-booking/pages/reset-password.vue")
  },
  {
    name: "set-password",
    path: "/set-password",
    meta: set_45passwordkg2xENniYRMeta || {},
    component: () => import("/codebuild/output/src4287943582/src/gx-booking/pages/set-password.vue")
  }
]